<template>
  <div>
    <!-- <div v-if="isNeedTopSpace" class="section-space-50"></div>
    <div
      :class="['content-loader ', isClass && isClass.length > 0 ? isClass : '']"
    >
      <span style="font-size: 40px">{{ loadingMessage || "Loading..." }}</span>
    </div> -->

    <section>
      <div class="container no-movie-found my-4 d-none d-md-block">
        <div class="row">
          <div class="col-md-3">
            <!-- <img
              src="@/assets/img/backgrounds/popcorn.svg"
              class="img-fluid"
              alt
            /> -->
          </div>
          <div class="col-md-6 align-self-center text-center">
            <!-- <h5 class="title">oh no.</h5>
            <p class="text">
              Because of the current pandemic, all screenings
              <br />have been called off. We’ll be back soon!
            </p> -->
            <!-- <div class="section-loader-new">
              <div class="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div> -->
          </div>
          <div class="col-md-3 align-self-end text-right">
            <!-- <img
              src="@/assets/img/backgrounds/babycorn.svg"
              class="img-fluid"
              alt
            /> -->
          </div>
        </div>
      </div>

      <!-- MOBILE SITE -->
      <div class="container my-4 d-md-none">
        <div class="no-movie-found">
          <div class="row pt-5">
            <div class="col-3">
              <!-- <img
                src="@/assets/img/backgrounds/popcorn.svg"
                class="img-fluid"
                alt
              /> -->
            </div>
            <div class="col-6 align-self-center text-center align-self-end">
              <!-- <h5 class="title">oh no.</h5> -->
              <!-- <div class="section-loader-new">
                <div class="lds-spinner">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div> -->
            </div>
            <div class="col-3 align-self-end">
              <!-- <img
                src="@/assets/img/backgrounds/babycorn.svg"
                class="img-fluid"
                alt
              /> -->
            </div>
          </div>
        </div>
        <!-- 
        <p class="text">
          Because of the current pandemic, all screenings have been called off.
          We’ll be back soon!
        </p> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    isClass: {
      type: String,
      default: ""
    },
    isNeedTopSpace: {
      type: Boolean,
      default: false
    },
    loadingMessage: {
      type: String,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/common/ComponentContentLoader.vue